import React from 'react'
import classnames from 'classnames'

import { Feature } from '../../../core/items'
import {
  getFeatureDisplayName,
  getFeatureDisplayContent,
} from '../../../core/i18n'
import {
  SupportedLanguageCode,
  LANGUAGE_CODES,
} from '../../../core/i18n'
import { strings } from './each-item-content'
import styles from '../../styles/modules/table.module.scss'
import formStyles from '../../styles/modules/each-item/each-item-forms.module.scss'
import Button from '../button'

interface Props {
  features: Feature[]
  newFeature: Feature
  activeLanguage: SupportedLanguageCode
  onChangeFeatures: (event: React.ChangeEvent<HTMLInputElement>) => void
  onChangeNewFeature: (event: React.ChangeEvent<HTMLInputElement>) => void
  onAddNewFeature: () => void
  onDeleteFeature: (event: React.MouseEvent<HTMLElement>) => void
}

const FeaturesForm: React.FC<Props> = props => {
  const { activeLanguage } = props
  
  // 定数定義
  const isEnglishMode = activeLanguage === LANGUAGE_CODES.ENGLISH
  const featureNameFieldName = isEnglishMode
    ? `itemFeatureTranslations.${activeLanguage}.name`
    : 'name'
  const featureContentFieldName = isEnglishMode
    ? `itemFeatureTranslations.${activeLanguage}.content`
    : 'content'

  return (
    <div
      className={classnames({
        [styles.wrapper]: true,
        [styles.stocker]: true,
      })}
    >
      <table className={`${styles.container} ${styles.featuresTable}`}>
        <tbody>
          {props.features.map((elem, i) => (
            <tr className={styles.rowStatic} key={i}>
              <td className={styles.cell}>
                <input
                  className={formStyles.input}
                  value={getFeatureDisplayName(elem, activeLanguage)}
                  placeholder="その他の特徴名"
                  name={featureNameFieldName}
                  data-num={i}
                  onChange={props.onChangeFeatures}
                />
              </td>
              <td className={styles.cell}>
                <input
                  className={formStyles.input}
                  value={getFeatureDisplayContent(elem, activeLanguage)}
                  placeholder="内容"
                  name={featureContentFieldName}
                  data-num={i}
                  onChange={props.onChangeFeatures}
                />
              </td>
              <td className={styles.cell}>
                <Button
                  className={formStyles.deleteButton}
                  title={strings.delete}
                  data-num={i}
                  onClick={props.onDeleteFeature}
                />
              </td>
            </tr>
          ))}
          <tr className={styles.rowStatic}>
            <td className={styles.cell}>
              <input
                className={formStyles.input}
                value={getFeatureDisplayName(props.newFeature, activeLanguage)}
                placeholder="その他の特徴名"
                name={featureNameFieldName}
                onChange={props.onChangeNewFeature}
              />
            </td>
            <td className={styles.cell}>
              <input
                className={formStyles.input}
                value={getFeatureDisplayContent(
                  props.newFeature,
                  activeLanguage
                )}
                placeholder="内容"
                name={featureContentFieldName}
                onChange={props.onChangeNewFeature}
              />
            </td>
            <td className={styles.cell}>
              <Button
                className={formStyles.addButton}
                title={strings.add}
                disabled={
                  !getFeatureDisplayName(props.newFeature, activeLanguage) ||
                  !getFeatureDisplayContent(props.newFeature, activeLanguage)
                }
                onClick={props.onAddNewFeature}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default FeaturesForm
